import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-shared-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './shared-card.component.html',
})
export class SharedCardComponent {
  additionalClasses = input<string>('mb-3 min-h-16 pl-4 flex items-center gap-2');
}
